import * as React from "react";
import { Icon } from "@chakra-ui/react";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { Button, Flex, Text, Wrapper, BackButton } from "components";
import {
  TOOTH_NUMBER_TO_TITLE,
  useCurrentCase,
  useNavigate,
  useParams
} from "duck";
import { getPrevNext } from "./duck";

const Header: React.FC = () => {
  const navigate = useNavigate();

  const { toothNumber, id } = useParams();
  const { species, milkOrAdultTeeth } = useCurrentCase(({ data }) => ({
    species: data.client.patient.species,
    milkOrAdultTeeth: data.client.patient.generalAssessment?.dentalChart
  }));

  if (!species || !milkOrAdultTeeth) {
    return null;
  }

  const { prev, next } = getPrevNext(species, milkOrAdultTeeth, +toothNumber);

  return (
    <Wrapper justifyContent="space-between" alignItems="center" display="flex">
      <BackButton chevron={false} />

      <Flex display="inline-flex" alignItems="center">
        <Button
          variant="unstyled"
          display="inline-flex"
          alignItems="center"
          onClick={() =>
            navigate(`/cases/${id}/dental-charting/${prev}`, { replace: true })
          }
        >
          <Icon as={IoChevronBack} boxSize="26px" />
        </Button>{" "}
        <Text fontWeight="semibold" fontSize="2xl" color="gray.700">
          {toothNumber} - {TOOTH_NUMBER_TO_TITLE[toothNumber]}
        </Text>{" "}
        <Button
          variant="unstyled"
          display="inline-flex"
          alignItems="center"
          onClick={() =>
            navigate(`/cases/${id}/dental-charting/${next}`, { replace: true })
          }
        >
          <Icon as={IoChevronForward} boxSize="26px" />
        </Button>
      </Flex>

      <div style={{ width: "40px", height: "40px" }} />
    </Wrapper>
  );
};

export default Header;
